var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentTag,{tag:"component",staticClass:"auth-provider-btn flex items-center justify-center gap-2 rounded-md py-3 text-sm font-medium text-white/80",class:[
    _vm.providerClass,
    {
      'w-full': _vm.fullWidth,
      'cursor-not-allowed': _vm.disabled,
      'pointer-events-none': _vm.isLink && _vm.disabled
    }
  ],attrs:{"href":_vm.isLink && !_vm.disabled ? _vm.href : undefined,"type":_vm.isLink ? undefined : _vm.type,"disabled":!_vm.isLink && _vm.disabled,"aria-disabled":_vm.disabled ? 'true' : undefined},on:{"click":_vm.handleClick}},[_c('z-icon',{attrs:{"icon":_vm.icon,"size":_vm.iconSize,"color":_vm.iconColorComputed}}),_vm._v(" "),_c('span',{staticClass:"auth-provider-btn__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }